import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "@xo-union/tk-component-icons";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../styles.css";
const DisplayElement = _ref => {
  let {
    as: ComponentToRender,
    children,
    classes: classesProp,
    className,
    color,
    iconName,
    labelDirection,
    size,
    disabled,
    htmlDisabled,
    ...props
  } = _ref;
  const classes = useClasses(styles, classesProp);
  const linkClasses = cx(classes['display-link'], color === 'primary' && classes.primary, color === 'primary-alternative' && classes.primaryAlternative, color === 'secondary' && classes.secondary, color === 'tertiary' && classes.tertiary, disabled && classes.disabled, className);
  const tappableAreaClasses = cx(classes['tappable-area'], size === 'md' && classes.md, size === 'lg' && classes.lg, iconName && classes[`has-${labelDirection || 'right'}-label`]);
  const disabledProps = disabled ? {
    'aria-disabled': true
  } : {};
  const htmlDisabledProps = htmlDisabled ? {
    disabled: htmlDisabled
  } : {};
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: linkClasses
  }, disabledProps, htmlDisabledProps, props), /*#__PURE__*/React.createElement("div", {
    className: tappableAreaClasses
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: classes.icon,
    size: "sm",
    "aria-hidden": "true"
  }), children));
};
DisplayElement.defaultProps = {
  color: 'secondary',
  size: 'lg'
};
process.env.NODE_ENV !== "production" ? DisplayElement.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  /**
   * The link's content
   */
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType(['disabled', 'display-link', 'icon', 'tappable-area']),
  /**
   * Render disabled styles
   */
  disabled: PropTypes.bool,
  /**
   * Set `disabled` html prop
   */
  htmlDisabled: PropTypes.bool,
  /**
   * Class name to append
   */
  className: PropTypes.string,
  /**
   * Color class
   * */
  color: PropTypes.oneOf(['primary', 'primary-alternative', 'secondary', 'tertiary']),
  /**
   * Icon to place next to CTA text
   */
  iconName: PropTypes.string,
  /**
   * Determines whether the link text will be on the left or right side of the icon
   */
  labelDirection: PropTypes.oneOf(['left', 'right']),
  /**
   * Size class
   * */
  size: PropTypes.oneOf(['md', 'lg'])
} : void 0;
export default DisplayElement;